import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import LoadingText from 'app/components/LoadingText';
import PayverseDirectHeader from 'app/components/PayverseDirectHeader';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

interface ReturnForm {
  resultStatus: string;
  resultMessage: string;
  resultCode: string;
  tid: string;
  orderId: string;
  mallReserved: string;
  schemeGroup: string;
  schemeCode: string;
  approvalNo?: string;
  paymentUrl?: string;
}

interface SubmitForm {
  [key: string]: string;
}

const DirectIframePage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();
  const [resultForm, setResultForm] = useState<ReturnForm>();

  const [tid, setTid] = useState<string>('');
  const [approvalNo, setApprovalNo] = useState<string>('');
  const [returnUrl, setReturnUrl] = useState<string>('');
  const [iframeUrl, setIframeUrl] = useState<string>('');
  const [showIframe, setShowIframe] = useState<boolean>(false);

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      // returnUrl Set
      setReturnUrl(data.data.returnUrl);
      // 결과 Form 지정
      setResultForm({
        resultStatus: data.data.response.resultStatus,
        resultMessage: data.data.response.resultMessage,
        resultCode: data.data.response.resultCode,
        tid: data.data.response.tid,
        orderId: data.data.response.orderId,
        mallReserved: data.data.response.mallReserved,
        approvalNo: approvalNo,
        paymentUrl: iframeUrl,
        schemeGroup: data.data.response.schemeGroup,
        schemeCode: data.data.response.schemeCode,
      });
      // 상태코드 예외처리
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  useEffect(() => {
    const browserTypeJson = (lang: string) => {
      switch (lang) {
        case 'zh-TW':
          return 'cntr';
        case 'zh-CN':
          return 'cnsi';
        case 'en-US':
          return 'en';
        case 'ko':
          return 'ko';
        case 'ko-KR':
          return 'ko';
        case 'ja':
          return 'jp';
        default:
          return '';
      }
    };
    const userLanguage = navigator.language;
    const browserLanguage = browserTypeJson(userLanguage);
    if (browserLanguage !== '') {
      i18n.changeLanguage(browserLanguage);
      return;
    } else {
      i18n.changeLanguage('en');
    }
  }, []);

  useEffect(() => {
    if (resultForm) {
      createFormAndSubmit(resultForm);
    }
  }, [resultForm]);

  useEffect(() => {
    const paramTid = new URLSearchParams(searchParams).get('tid');
    const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
    const approvalNo = new URLSearchParams(searchParams).get('approvalNo');

    if (approvalNo) {
      setApprovalNo(approvalNo);
    }
    if (paramTid) {
      setTid(paramTid);
      setPaymentState(prevState => ({
        ...prevState,
        tid: paramTid,
      }));
    }
    if (paramPayUrl) {
      if (isMobile) {
        setIframeUrl(paramPayUrl);
        setShowIframe(true);
      } else {
        setIframeUrl(paramPayUrl);
        openPopup(paramPayUrl);
      }
    }
  }, [searchParams]);

  const createFormAndSubmit = formData => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  const openPopup = (url: string) => {
    const popupWindow = window.open(
      `/iframePopup?payUrl=${url}`,
      '_blank',
      'width=700,height=650',
    );

    if (popupWindow) {
      const checkPopupClosed = setInterval(() => {
        if (popupWindow.closed) {
          clearInterval(checkPopupClosed);
          handlePopupClose();
        }
      }, 1000);
    }
  };

  const handlePopupClose = () => {
    transactResult.mutate();
  };

  return (
    <>
      <div className="payverse-wrap">
        <div className="payverse">
          {iframeUrl && showIframe ? (
            <>
              <iframe
                id="payment-iframe"
                src={iframeUrl}
                width="100%"
                height="90%"
              ></iframe>
              <div
                className="c-section"
                style={{ height: '5%', display: 'flex', alignItems: 'center' }}
              >
                <div
                  className="box"
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    marginLeft: '0',
                    alignItems: 'center',
                  }}
                >
                  <button className="orange" onClick={handlePopupClose}>
                    {t('payment_confirm')}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="payverse-wrap">
              <div className="payverse">
                <PayverseDirectHeader />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    height: '70%',
                  }}
                >
                  <LoadingIndicator />
                  <LoadingText />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DirectIframePage;
